// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ob_D7bz7W","tabs_sticky":"ob_keeLkt","lockIcon":"ob_eXtffI"};